import { useCallback, useRef } from 'react';
import { SessionState } from 'sip.js';
/**
 * When an incoming ring session hits {@link SessionState.Terminated} without user action, clears {@link IncomingRing}.
 */
export function useIncomingRingTerminatedListeners(setIncomingRing) {
    const ringTerminatedListenersRef = useRef(new Map());
    const detachRingTerminatedListener = useCallback((session) => {
        const fn = ringTerminatedListenersRef.current.get(session);
        if (fn) {
            session.stateChange.removeListener(fn);
            ringTerminatedListenersRef.current.delete(session);
        }
    }, []);
    const attachRingTerminatedListener = useCallback((session) => {
        detachRingTerminatedListener(session);
        const onState = (st) => {
            if (st === SessionState.Terminated) {
                detachRingTerminatedListener(session);
                setIncomingRing((cur) => (cur?.session === session ? null : cur));
            }
        };
        ringTerminatedListenersRef.current.set(session, onState);
        session.stateChange.addListener(onState);
    }, [detachRingTerminatedListener, setIncomingRing]);
    return {
        attachRingTerminatedListener,
        detachRingTerminatedListener,
        ringTerminatedListenersRef,
    };
}
